import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormGroup} from '@angular/forms';
import {annuelNumber, etablissementType, salaryNumber} from "../../../../shared/utils/data/etablissments-data";

@Component({
  selector: 'app-second-form-step',
  templateUrl: './second-form-step.component.html',
  styleUrl: './second-form-step.component.scss'
})
export class SecondFormStepComponent implements OnInit{
  @Input() firstStepFormControl : FormGroup
  @Input() secondStepFormControl : FormGroup
  @Output() onSubmit = new EventEmitter<any>();

  showPassword : boolean
  constructor() {}
  ngOnInit(): void {

  }
 onSiretInputChange(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  const numericValue = inputElement.value.replace(/\D/g, '');
  if (numericValue.length > 14) {
    inputElement.value = numericValue.slice(0, 14);
  } else {
    inputElement.value = numericValue;
    }
   this.secondStepFormControl.get('numsiret')?.setValue(inputElement.value);

  }

  onFinessInputChange(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  const numericValue = inputElement.value.replace(/\D/g, '');
  if (numericValue.length > 9) {
    inputElement.value = numericValue.slice(0, 9);
  } else {
    inputElement.value = numericValue;
    }
   this.secondStepFormControl.get('numfiness')?.setValue(inputElement.value);

  }

  checkBoxChange(e: any, value: string) {
    this.secondStepFormControl.get('platformManagedBy')?.patchValue(value)
  }

  protected readonly etablissementType = etablissementType;
  protected readonly salaryNumber = salaryNumber;
  protected readonly annuelNumber = annuelNumber;
}
